const translations = { needHelp: '¿Necesita ayuda?', talkToBtime: 'Hable con Btime' }

export default translations
